import React from 'react';
import { Authenticator as AmplifyAuthenticator } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import { useSearchParamsValue } from '~/shared/hooks';
import ResetPasswordScreen from './ResetPasswordScreen';
import { signUpComponents, components, formFields, getSignUpFormFields } from './AuthComponents';

const amplifyconfig: any = {
  Auth: {
    region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
    userPoolId: process.env.REACT_APP_COGNITO_POOL_ID || 'us-east-1_sr2n4d09I',
    userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '13j6amf303a03dulhciq0vsahc',
    mandatorySignIn: false,
  },
};

Amplify.configure(amplifyconfig);

function AuthScreen() {
  const searchParams = useSearchParamsValue();
  const isSignUp = window.location.href.includes('complete-signup');
  const isResetPassword = window.location.href.includes('complete-reset-password');
  const signUpFormFields = getSignUpFormFields(searchParams);

  if (isResetPassword) return <ResetPasswordScreen />;

  return (
    <div
      className={isSignUp ? 'sign-up' : 'sign-in'}
      data-cy="auth-screen"
      style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}
    >
      <img alt="mktmediastats" style={{ width: 300, marginBottom: '25px', display: 'flex' }} src="/LoginLogo.png" />
      <AmplifyAuthenticator
        formFields={isSignUp ? signUpFormFields : formFields}
        components={isSignUp ? signUpComponents : components}
        hideSignUp={true}
      >
        {({ signOut, user }) => {
          return <div id={user?.getUsername()} onClick={signOut} />;
        }}
      </AmplifyAuthenticator>
    </div>
  );
}

export default AuthScreen;
